import { render, staticRenderFns } from "./ConsumptionReport.vue?vue&type=template&id=7c7970b8&"
import script from "./ConsumptionReport.vue?vue&type=script&lang=js&"
export * from "./ConsumptionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c7970b8')) {
      api.createRecord('7c7970b8', component.options)
    } else {
      api.reload('7c7970b8', component.options)
    }
    module.hot.accept("./ConsumptionReport.vue?vue&type=template&id=7c7970b8&", function () {
      api.rerender('7c7970b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/kiosk/reports/ConsumptionReport.vue"
export default component.exports